// extracted by mini-css-extract-plugin
export default {"finishStage":"FinishStage_finishStage__pPWeJ","content":"FinishStage_content__SOMZi","controls":"FinishStage_controls__LHgXw","controlsButton":"FinishStage_controlsButton__FV7Se"};